import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { vh } from 'components/utils/helper';
import { Skeleton } from 'antd';

const ApexChart = (props) => {
    const options = {
        chart: {
            type: 'candlestick',
            height: 350,
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            candlestick: {
                colors: {
                    upward: '#21DDB8',
                    downward: '#164997'
                },
                wick: {
                    useFillColor: true
                }
            }
        },
        stroke: {
            curve: 'smooth',
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            opposite: true,
            labels: {
                align: "right"
            },
            tooltip: {
                enabled: true
            }
        }
    };

    const [series, setSeries] = useState([{
        data: props?.historicData
    }]);

    useEffect(() => {
        setSeries([{ data: props.historicData }]);
    }, [props.historicData]);


    return (
        <>
            {props.historicData?.length ?
                <div className='h-full'>
                    <div id="chart" className='h-full'>
                        <Chart options={options} series={series} type="candlestick" height={vh(50)} />
                    </div>
                </div>
                : <Skeleton />
            }
        </>
    );
};

export default ApexChart;
